import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import {OAuthService} from "angular-oauth2-oidc";

@Injectable()
export class AuthGuardService  {

  constructor(public auth: AuthService, public router: Router) {}

  canActivate(): boolean {
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['/login']).then();
      return false;
    } else {
      return true;
    }
  }
}
